import { ILogOrganizationContext, ILogUserContext } from './log-context.interface';


export const defaultUserContext: Readonly<ILogUserContext> = {
  userId: 'unknownUser',
  userName: 'unknownUser',
};

export const defaultOrganizationContext: Readonly<ILogOrganizationContext> = {
  organizationId: 'noCurrentOrganization',
  organizationName: 'noCurrentOrganization',
};
